import { get, isString } from 'lodash'

/**
 *
 * @param module
 * @return {*}
 */
export function bootstrap(module) {
  if (module.getters === undefined) {
    module.getters = {}
  }

  if (module.mutations === undefined) {
    module.mutations = {}
  }

  Object.keys(module.state).forEach((key) => {
    if (module.getters[key] === undefined) {
      module.getters[key] = (state) => state[key]
    }
    if (module.mutations[key] === undefined) {
      module.mutations[key] = (state, value) => {
        state[key] = value
      }
    }
  })

  return module
}

/**
 *
 * @param store
 * @param name
 * @param suffix
 * @return {*|string}
 */
const generateModuleName = (store, name, suffix = 0) => {
  const nameWithSuffix = name !== 'formDesignerStore' ? (suffix === 0 ? `${name}-1` : `${name}-${suffix}`) : name
  const moduleExists = typeof store.state[nameWithSuffix] !== 'undefined'

  if (!moduleExists) {
    return nameWithSuffix
  }

  const nextSuffix = suffix + 1
  return generateModuleName(store, name, nextSuffix)
}

/**
 *
 * @param store
 * @param module
 * @param name
 * @param panelId
 * @param unique
 * @return {{namespace: (*|string)}}
 */
export function createStore(store, module, name, panelId, unique) {
  const moduleName = unique ? name : generateModuleName(store, name, panelId)
  store.registerModule(moduleName, module)
  return {
    namespace: moduleName,
  }
}

export const VueInstanceStorePlugin = {
  /**
   *
   * @param Vue
   */
  install(Vue) {
    Vue.mixin({
      beforeCreate() {
        let panelId = get(this.$options, 'propsData.panelId')
        if (panelId && isString(panelId)) panelId = Number(get(panelId.match(/\d+$/), '0', 0))
        const hasInstanceStore = typeof this.$options.instanceStore === 'object'

        if (!(hasInstanceStore || (this.$parent && this.$parent.$storeNamespace)) || this.ranBefore) {
          return
        }

        const isUniqueNamespace = !!get(this.$options, 'propsData.namespace')
        const namespaceName = isUniqueNamespace
          ? get(this.$options, 'propsData.namespace')
          : get(this.$options, 'instanceStore.name')
        const { namespace } = hasInstanceStore
          ? createStore(this.$store, this.$options.instanceStore.module, namespaceName, panelId, isUniqueNamespace)
          : { namespace: this.$parent.$storeNamespace }

        this.$get = (prop, inputNamespace = null) =>
          get(this.$store, ['getters', `${inputNamespace || namespace}/${prop}`])
        this.$state = (prop) => this.$store.state[`${namespace}/${prop}`]
        this.$commit = (mutation, payload) => this.$store.commit(`${namespace}/${mutation}`, payload)
        this.$dispatch = (action, payload, inputNamespace = null) =>
          this.$store.state[`${inputNamespace || namespace}`]
            ? this.$store.dispatch(`${inputNamespace || namespace}/${action}`, payload)
            : null
        this.$storeNamespace = namespace

        if (this.$store._mutations[`${namespace}/SET_NAMESPACE`]) {
          this.$store.commit(`${namespace}/SET_NAMESPACE`, namespace)
        }

        // hack to stop beforeCreate running multiple times fo the exact same component...
        this.ranBefore = true
      },
    })
  },
}
